// Снимок недели (016: data-model.md, «Тело снимка»; research Р1; ADR-0032, ADR-0034): неизменяемая
// копия протокола на ревизии фиксации — пункты с полями и оформлением, колонки, ответственные с
// именем на момент фиксации. Тело совпадает с состоянием таблицы: экран снимка, печать и XLSX
// строятся одной функцией из рабочего состояния или тела снимка (WEEK-06).
import { z } from '../kernel/zod.ts';
import { DateSchema, IdSchema, PersonRefSchema, TimestampSchema } from '../kernel/common.ts';
import { ItemRowSchema } from './item.ts';
import { ProtocolColumnSchema } from './protocol.ts';

export const SnapshotParamsSchema = z.object({ id: IdSchema, snapshotId: IdSchema });

export const SnapshotListItemSchema = z.object({
  id: IdSchema,
  weekDate: DateSchema,
  title: z.string(),
  /** Ревизия фиксации: граница истории снимка (WEEK-03). */
  revision: z.number().int().min(1),
  itemCount: z.number().int().min(0),
  createdAt: TimestampSchema,
  createdBy: PersonRefSchema,
});
export type SnapshotListItem = z.infer<typeof SnapshotListItemSchema>;

export const SnapshotListSchema = z.object({ items: z.array(SnapshotListItemSchema) });
export type SnapshotList = z.infer<typeof SnapshotListSchema>;

export const SnapshotBodySchema = z.object({
  lastSnapshotRevision: z.number().int().min(0).optional(),
  format: z.literal(1),
  /** П-N. */
  number: z.number().int().min(1),
  title: z.string(),
  weekDate: DateSchema,
  sheetDate: DateSchema.nullable(),
  transferRevision: z.number().int().min(1),
  templateVersion: z.number().int().min(1).nullable(),
  columns: z.array(ProtocolColumnSchema),
  /** Пункты поколения в порядке дерева, у ответственных — имя на момент фиксации. */
  items: z.array(ItemRowSchema),
});
export type SnapshotBody = z.infer<typeof SnapshotBodySchema>;

export const SnapshotViewSchema = SnapshotListItemSchema.extend({ body: SnapshotBodySchema });
export type SnapshotView = z.infer<typeof SnapshotViewSchema>;
